import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as uiActions from 'modules/ui';
import * as dataActions from 'modules/fetchData';
import Catalog from 'components/Lookbook/Catalog';

class CatalogContainer extends Component {
  render() {
    const {
      match,
      color,
      lookbookData,
      DataActions,
      toggleBacklist,
      UIActions,
      history
    } = this.props;
    const index = match.params.season;

    return (
      <Catalog
        goBack={history.goBack}
        UIActions={UIActions}
        toggleBacklist={toggleBacklist}
        color={color}
        lookbookData={lookbookData[index]}
        DataActions={DataActions}
        index={index}
      />
    );
  }
}

export default connect(
  state => ({
    color: state.ui.get('color'),
    showGallery: state.ui.get('showGallery'),
    toggleBacklist: state.ui.get('toggleBacklist'),
    lookbookData: state.fetchData.get('lookbook').toJS()
  }),
  dispatch => ({
    UIActions: bindActionCreators(uiActions, dispatch),
    DataActions: bindActionCreators(dataActions, dispatch)
  })
)(CatalogContainer);



// WEBPACK FOOTER //
// ./src/containers/CatalogContainer.js